import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function BlogListpub() {
  // getBlogListPub
  const navigate = useNavigate();
  const blog_list = useSelector((state) =>
    state?.allapi?.blog_list ? state?.allapi?.blog_list : {}
  );
  const get_blog_category_list = useSelector((state) =>
    state?.allapi?.get_blog_category_list
      ? state?.allapi?.get_blog_category_list
      : []
  );
  const get_recent_blog_list = useSelector((state) =>
    state?.allapi?.get_recent_blog_list
      ? state?.allapi?.get_recent_blog_list
      : []
  );

  console.log(get_recent_blog_list);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allapiAction.getBlogListPub(1));
    // dispatch(allapiAction.getblogcateAllList({}));
    dispatch(allapiAction.getrectentBlog({}));

    return () => {};
  }, []);

  return (
    <div>
      {" "}
      <div class="page-title">
        <div class="container-fluid">
          <div class="page-caption text-center">
            <h1>
              <br />
              Job In Grid
            </h1>
          </div>
        </div>
      </div>
<div className="container mt-5">
  <div className="row">
    {/* Blog List */}
    <div className="col-lg-8">
      {blog_list?.docs &&
        blog_list?.docs?.map((data, i) => {
          return (
            <div
              key={i}
              className="blog-card shadow-lg rounded overflow-hidden mb-5"
            >
              <div className="blog-img-wrap">
                <img
                  src={URL?.API_BASE_URL + data?.feature_image}
                  className="img-fluid blog-img"
                  alt={data?.title}
                  onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}
                />
              </div>
              <div className="p-4 bg-white">
                <p className="text-muted small mb-1">
                  <i className="fa fa-calendar accent-color"></i>&nbsp;
                  {moment(data?.createdAt).format("MMM DD, YYYY")}
                </p>
                <h3 className="fw-bold blog-title mb-2">{data?.title} onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}</h3>
                <p className="text-secondary">{data?.short_description} onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}</p>
                <button
                  type="button"
                  className="btn btn-accent mt-2 px-4 py-2"
                  onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}
                >
                  Read More →
                </button>
              </div>
            </div>
          );
        })}
    </div>

    {/* Sidebar */}
    <div className="col-lg-4">
      <div className="p-4 bg-light rounded shadow-sm">
        <h5 className="fw-bold border-bottom pb-2 mb-3">Recent Posts</h5>
        {get_recent_blog_list &&
          get_recent_blog_list?.map((data, i) => {
            return (
              <div key={i} className="d-flex align-items-center mb-3 recent-post">
                <img
                  src={URL?.API_BASE_URL + data?.feature_image}
                  alt={data?.title}
                  className="rounded me-3 recent-img"
                />
                <div>
                  <p className="m-0 fw-semibold recent-title" onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }} >{data?.title}</p>
                  <span className="small text-muted" onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}>
                    {moment(data?.createdAt).format("MMM DD, YYYY")}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  </div>
</div>



    </div>
  );
}

export default BlogListpub;
